<template>
	<portal selector="#helicopter-tiers">
		<transition name="fade">
			<nav class="filter-nav type--s">
				<div class="filter-nav__list underline">
					<a
						role="button"
						:class="[ linkClasses, { 'is-active' : activeID === null } ]"
						@click="$emit('click', null)"
					>Show All</a>
					<a
						role="button"
						v-for="category in categories"
						:class="[ linkClasses, { 'is-active' : activeID === category.id } ]"
						:key="category.id"
						@click="$emit('click', category.id)"
					>{{category.name}}</a>
				</div>
			</nav>
		</transition>
	</portal>
</template>

<script>
export default {
	data() {
		return {
			linkClasses: 'filter-nav__link underline-child'
		}
	},

	props: {
		categories: {
			type: Array,
			default: () => []
		},
		activeID: {
			type: Number,
			default: null
		}
	}
}
</script>

<style lang="scss" scoped></style>
